import { SubscriptionDescriptionsData } from "@/types";
import { SubscriptionDescriptionAdminzoneState } from "@/types/store/adminzone";

export const state: SubscriptionDescriptionAdminzoneState = {
  subscriptionDescriptions: [] as Array<SubscriptionDescriptionsData>
}
